export default {
  computed: {
    $app() {
      return this.$root.$children[0] ? this.$root.$children[0] : undefined
    }
  }
}
